export const getAccountName = () => {
    const name = String(window.location.host.split(".")[0])
        .replace(/http?:\/\//, "")
        .replace(/:.*/, "")
    if (name === "localhost" || name === "quizzical-elion-4e2c7e")
        return 'newdesign';
    return name;
}